d<template>
  <div class="absolute fill-height events-page">
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>
      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <!--<v-layout row wrap>
              <v-breadcrumbs divider="/" large disabled="false" class="pa-0">
                <v-icon slot="divider">chevron_right</v-icon>
                <v-breadcrumbs-item>
                  <v-btn color="blue" outline @click="gotoall" class="ma-0">Sklady</v-btn>
                </v-breadcrumbs-item>
                <v-breadcrumbs-item>
                  Pohyby ve skladu hotových výrobků
                </v-breadcrumbs-item>
              </v-breadcrumbs>
            </v-layout>-->
            <v-layout row wrap>
              <v-flex xs12>
                <h3>Pohyby ve skladu hotových výrobků</h3>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="mt-3">
              <v-flex xs12 sm6 md2>
                <sklady all v-model="sklad"></sklady>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <v-menu offset-y right v-model="menu" :close-on-content-click="false" class="d-flex grow">
                  <v-text-field
                    label="Datum"
                    v-model="datum"
                    slot="activator"
                    readonly
                    class="mx-2"
                  ></v-text-field>
                  <v-card>
                    <v-card-text>
                      <DateRangePicker
                        :options="dateRangeOptions"
                        @input="onDateRangeChange"
                        :labels="labels"
                        @close="menu=false"
                      />
                    </v-card-text>
                  </v-card>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <productsearch label="Hledaný produkt" v-model="produkt"></productsearch>
              </v-flex>
              <v-flex xs12 sm6 md2>
                <seriovecislosearch label="Zadejte sériové číslo" v-model="seriove_cislo"></seriovecislosearch>
              </v-flex>
              <v-flex xs12 sm6 md2>
                <osobasearch label="Hledaný klient / spolupracovník" v-model="klient" :all="true"></osobasearch>
              </v-flex>
            </v-layout>
            <div class="table-border__radius elevation-1">
              <v-data-table
                :headers="headers"
                :items="items"
                :pagination.sync="pagination"
                :total-items="pagination.totalItems"
                :rows-per-page-items="[25, 50, 100, 200]"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.datum | formatDate }}</td>
                  <td>
                    <router-link :to="{ path: '/produkty/' + props.item.produkt.id }" target="_blank">
                      {{ props.item.produkt.nazev }}
                    </router-link>
                  </td>
                  <td class="text-xs-right">
                    <span v-if="props.item.typ_pohybu=='vydej'">- </span>{{ props.item.mnozstvi }} ks <v-icon v-if="props.item.typ_pohybu == 'prijem'" small color="green">arrow_upward</v-icon><v-icon v-else small color="red">arrow_downward</v-icon></td>
                  <td>
                    <span v-if="props.item.typ_pohybu=='prijem'">Příjem</span><span v-else-if="props.item.typ_pohybu=='vydej'">Výdej</span>
                  </td>
                  <td>
                    <router-link :to="{ path: '/dodavatele/objednavky/'+props.item.dodavatel_objednavka_id}" target="_blank" v-if="props.item.typ_pohybu=='prijem' && props.item.dodavatel != null">
                      <span>{{ props.item.dodavatel.nazev}} ({{props.item.cislo_objednavky}})</span>
                    </router-link>
                  </td>
                  <td>
                    <router-link :to="{ path: '/klienti/'+props.item.klient.id}" target="_blank" v-if="props.item.typ_pohybu=='vydej' && props.item.klient != null">
                      {{ props.item.klient.nazev_osoby}}
                    </router-link>
                  </td>
                  <td>
                    {{props.item.poznamka}}
                  </td>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
import Loader from '@/components/Loader'
import DateRangePicker from '@/components/DateRange';
export default {
  extends: Base,
  data () {
    return {
      loading: false,
      headers: [
        { text: 'Datum', value: 'datum' },
        { text: 'Produkt', value: 'produkt' },
        { text: 'Množství', value: 'mnozstvi', align: 'right' },
        { text: 'Typ pohybu', value: 'typ_pohybu' },
        { text: 'Dodavatel (objednávka)', value: 'cislo_objednavky' },
        { text: 'Klient (předáno)', value: 'klient' },
        { text: 'Poznámka', value: 'poznamka', sortable: false }
      ],
      items: [],
      sklad: null,
      produkt: null,
      klient: null,
      counter: 0,
      menu: false,
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 50,
        sortBy: "datum",
        totalItems: 0
      },
      range: [],
      labels: {
        start: "Začátek",
        end: "Konec"
      },
      dateRangeOptions: {
        startDate: moment().subtract("days", 7).format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        format: 'DD.MM.YYYY',
        presets: [
          {
            label: 'Dnes',
            range: [
              moment().format('YYYY-MM-DD'),
              moment().format('YYYY-MM-DD'),
            ],
          },
          {
            label: 'Včera',
            range: [
              moment().subtract("days", 1).format('YYYY-MM-DD'),
              moment().subtract("days", 1).format('YYYY-MM-DD'),
            ],
          },
          {
            label: 'Tento týden',
            range: [
              moment().startOf("week").format('YYYY-MM-DD'),
              moment().endOf("week").format('YYYY-MM-DD'),
            ],
          },
          {
            label: 'Minulý týden',
            range: [
              moment().subtract("weeks", 1).startOf("week").format('YYYY-MM-DD'),
              moment().subtract("weeks", 1).endOf("week").format('YYYY-MM-DD'),
            ],
          },
          {
            label: 'Tento měsíc',
            range: [
              moment().startOf("month").format('YYYY-MM-DD'),
              moment().endOf("month").format('YYYY-MM-DD'),
            ],
          },
          {
            label: 'Minulý měsíc',
            range: [
              moment().subtract("months", 1).startOf("month").format('YYYY-MM-DD'),
              moment().subtract("months", 1).endOf("month").format('YYYY-MM-DD'),
            ],
          }
        ],
      },
      datum_od: null,
      datum_do: null,
      datum: null,
      seriove_cislo: null,
      menu: false
    }
  },
  /*methods: {
    gotoall () {
      this.$router.push({ path: "/sklad/sklad-hotovych-produktu" });
    },
    onDateRangeChange () {

    }
  },*/
  watch: {
    sklad () {
      this.load();
    },
    produkt () {
      this.load();
    },
    seriove_cislo () {
      this.load();
    },
    klient () {
      this.load();
    },
    pagination: {
      handler () {
        this.load();
      },
      deep: true
    },
    datum_od () {
      this.datum = moment(this.datum_od*1000).format("DD.MM.YYYY") + " - " + moment(this.datum_do*1000).format("DD.MM.YYYY");
    },
    datum_do () {
      this.datum = moment(this.datum_od*1000).format("DD.MM.YYYY") + " - " + moment(this.datum_do*1000).format("DD.MM.YYYY");
    }
  },
  mounted: function() {
    window.MenuListener.show();
    this.load();
    this.datum_od = parseInt(moment().subtract("days", 30).startOf("day")._d.getTime()/1000);
    this.datum_do = parseInt(moment().endOf("day")._d.getTime()/1000);
  },
  methods: {
    queryList: function() {
      if (this.timeout != null)
        clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        this.pagination.page = 1;
        this.load();
      }.bind(this), 200)
    },
    load: function() {
      this.counter++;
      this.loadingTable = true;
      window.API.post("sklady/hotove-vyrobky-pohyby/search", {
        pagination: this.pagination,
        s: this.search,
        echo: this.counter,
        sklad: this.sklad,
        produkt: parseInt(this.produkt),
        datum_od: this.datum_od,
        datum_do: this.datum_do,
        klient: this.klient,
        seriove_cislo: this.seriove_cislo
      }).then(function(body) {
        if (this.counter != body.echo)
          return;
        var c = 0;
        this.items.replace(body.data.map((e) => { e.i = c++; return e; }));
        this.pagination.sortBy = body.sort.sortBy;
        this.pagination.descending = body.sort.descending;
        this.pagination.page = body.sort.page;
        this.pagination.rowsPerPage = body.sort.rowsPerPage;
        this.pagination.totalItems = body.sort.totalItems;
        this.loading = false;
        this.loadingTable = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    selected (v) {
      this.start = parseInt(moment(v.start).add("-1", "days")._d.getTime()/1000);
      this.end = parseInt(moment(v.end).add("-1", "days")._d/1000);
      this.load();
    },
    onDateRangeChange (e) {
      this.datum_od = parseInt(moment(e[0]).startOf("day")._d.getTime()/1000);
      this.datum_do = parseInt(moment(e[1]).endOf("day")._d.getTime()/1000);
      this.load();
    }
  },
  components: {
    DateRangePicker
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Sklady/PohybyVeSkladuHotovychVyrobku.vue